// extracted by mini-css-extract-plugin
export var dropdownButton = "_2d-0";
export var fullWidthDropdownButton = "_2d-1";
export var icon = "_2d-3";
export var iconPlaceholder = "_2d-2";
export var menuItemRow = "_2d-9";
export var separator = "_2d-e";
export var shortcutContainer = "_2d-7";
export var shortcutContainerFilled = "_2d-8";
export var shortcutIconLg = "_2d-6";
export var shortcutIconMd = "_2d-5";
export var shortcutIconSm = "_2d-4";
export var submenuChevron = "_2d-d";
export var submenuDropdown = "_2d-a";
export var submenuTriggerRow = "_2d-b";
export var submenuTriggerRowOpen = "_2d-c";